import { render, staticRenderFns } from "./Duel_Statistics_Row.vue?vue&type=template&id=3fe495eb&scoped=true&"
import script from "./Duel_Statistics_Row.vue?vue&type=script&lang=js&"
export * from "./Duel_Statistics_Row.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Statistics_Row.vue?vue&type=style&index=0&id=3fe495eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe495eb",
  null
  
)

export default component.exports